import { Component, OnInit, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivationEnd, NavigationEnd, ResolveEnd, Router, RouterModule } from '@angular/router';
import { OidcService } from '../shared/services/oidc.service';
import { CommonModule, Location } from '@angular/common';
import { configuration } from '../../environments/config';
import { DomSanitizer } from '@angular/platform-browser';
import { MyOverlayRef } from '../shared/overlay/myoverlay-ref';
import { OverlayService } from '../shared/overlay/overlay.service';
// import { HelpComponent } from './help/help.component';
import { first, filter } from 'rxjs/operators';
import { deviceService } from '../shared/servicesHardware/deviceService';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material-module';
import { LoginComponent } from '../login/login.component';
import { tools } from '../shared/services/tools';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, RouterModule, LoginComponent],
  templateUrl: './menu.html',
  styleUrl: './menu.scss'
})
export class Menu implements OnInit, AfterViewInit {

  @ViewChild('sidenav') public sidenav: any;

  public currentPage: string = "";
  public isConnected: boolean = false;
  public imgLogo = "./assets/data/" + configuration.logo;
  public ispageTypeLoginPath: boolean = false;

  public listItems: menuItem[] = []
  public listItemsBase: menuItem[] = [
    { icon: 'home', title: 'Accueil', divider: false, subTitle: '', pageLink: '/home' },
    { icon: 'receipt', title: 'Factures', divider: false, subTitle: '', pageLink: '/factures' },
    { icon: 'description', title: 'Commandes', divider: false, subTitle: '', pageLink: '/commandes' },
    { icon: 'swap_horiz', title: 'Appels à support', divider: false, subTitle: '', pageLink: '/appelASupport' },
  ];

  public pageTypeLoginPath: string[] = ['/login', '/forgot-password', '/set-password', '/reset-password']

  private currentPageTitleOverload: any[] = [
    { title: 'factures', titleOverload: 'Factures' },
    { title: 'commandes', titleOverload: 'Commandes' },
    { title: 'factureElectronique', titleOverload: 'Factures électronique' },
    { title: 'planning', titleOverload: 'Audit, Réunions' },
    { title: 'audit/sequence', titleOverload: 'Séquences, Audit flash' },
    { title: 'audit/maps', titleOverload: 'Maps, Audit flash' },
    { title: 'pointage', titleOverload: 'Pointage' },
    { title: 'appelASupport', titleOverload: 'Appels à support ' },
    { title: 'app-not-found', titleOverload: '404 page not found' },
    { title: 'mentions-legales', titleOverload: 'Mentions légales' },
    { title: 'set-password', titleOverload: 'Définition du mot de passe' },
    { title: 'forgot-password', titleOverload: 'Définition du mot de passe' },
    { title: 'home', titleOverload: 'Accueil' },
  ];
  public userLogin: string | null = null;


  constructor(public location: Location, public oidc: OidcService, private router: Router,
    protected sanitizer: DomSanitizer, private tools: tools) {
    document.title = "Obexto espace client";
    this.checkCurrentPage();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((evt: NavigationEnd) => {
      this.isConnected = false;
      this.checkCurrentPage();
    });
  }

  private checkCurrentPage() {
    this.listItems = JSON.parse(JSON.stringify(this.listItemsBase));
    let pathLocation = this.location.path();
    if (this.oidc.isConnected() == true && this.pageTypeLoginPath.filter(path => path == pathLocation).length == 0) {
      this.tools.delay(100).then(() => {
        this.userUpdate()
        this.ispageTypeLoginPath = false;
        this.isConnected = true;
        this.currentPage = this.currentPageTitleOverload.find(page => pathLocation.includes(page.title))?.titleOverload || "";
        //user connected => me option available in localstorage 
        let me = localStorage.getItem("me");
        if (me) {
          let meObj = JSON.parse(me);
          if (meObj?.permissions?.length > 0) {
            for (let i = 0; i < meObj.permissions.length; i++) {
              const permission = meObj.permissions[i];
              if (permission?.facturXUploadAccessLevel == 1 || permission?.facturXDownloadAccessLevel == 1) {
                const hasFactureElectronique = this.listItems.some(item => item.pageLink === '/factureElectronique');
                if (!hasFactureElectronique) {
                  this.listItems.push({ icon: 'receipt', title: 'Facture électronique', divider: false, subTitle: '', pageLink: '/factureElectronique' });
                }
                break;
              }
            }
          }
        }
      })
    }
    else {
      this.ispageTypeLoginPath = true;
      if (this.location.path() == "")
        this.router.navigate(['/login']);
    }
  }

  public ngOnInit() {
  
  }

  ngAfterViewInit(): void {
    this.userUpdate()
  }

  private userUpdate() {
    this.userLogin = localStorage.getItem("loginMail");
  }


  public logout() {
    this.sidenav.toggle();
    this.oidc.logout();
    this.isConnected = false;
  }
}

export interface menuItem {
  // use fake backend in place of Http service for backend-less development
  icon: string;
  title: string;
  subTitle: string;
  divider: boolean;
  pageLink: string;
};

